import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class ContentService extends BaseService {
  getContentList = (values) => {
    const { executedTeam, type } = values;
    return this.axios.get(`${API_ENDPOINTS.CONTENT_LIST}`, {
      params: {
        executedTeam: executedTeam,
        type,
      },
    });
  };

  searchContents = (data) => {
    return this.axios.post(API_ENDPOINTS.CONTENT_SEARCH, { ...data });
  };

  getContent = (contentId) => {
    return this.axios.get(
      API_ENDPOINTS.CONTENT_BY_ID.replace("{contentId}", contentId)
    );
  };

  updateContent = (contentId, data) => {
    return this.axios.put(
      API_ENDPOINTS.CONTENT_BY_ID.replace("{contentId}", contentId),
      data
    );
  };

  createContent = (data) => {
    return this.axios.post(API_ENDPOINTS.CREATE_CONTENT, data);
  };

  deleteContent = (contentId) => {
    return this.axios.delete(
      API_ENDPOINTS.CONTENT_BY_ID.replace("{contentId}", contentId)
    );
  };

  resumeContent = (contentId) => {
    return this.axios.put(
      API_ENDPOINTS.CONTENT_RESUME.replace("{contentId}", contentId)
    );
  };
}
